import { z } from "zod";

import { fetchWithThrow } from "@rosette/web_utils/src/fetchWithThrow.js";
import type { AchievementType } from "@rosette/ts/src/business/achievement/AchievementType.js";


export const GrantAchievementRequest = z.object({
    userPublicID: z.string(),
    achievementID: z.string(),
});
export type GrantAchievementRequest = z.infer<typeof GrantAchievementRequest>;


export const GrantAchievementResponse = z.object({
    success: z.boolean(),
});
export type GrantAchievementResponse = z.infer<typeof GrantAchievementResponse>;


export async function grantAchievement(userPublicID: string, achievement: AchievementType): Promise<void> {
    const request: GrantAchievementRequest = {
        userPublicID,
        achievementID: achievement.getID(),
    };
    const response = await fetchWithThrow("/api/admin/grantAchievement", {
        method: "POST",
        credentials: "include",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(request),
    });
    GrantAchievementResponse.parse(await response.json());
}
